import { AirlineOrderGrouping } from "./entity";
import DtoList from "../../base_classes/dto_list";
import { type JSONData } from "../../base_classes/dto.d";
import { type IAirlineOrderGroupingList } from "./list.gen.d";
import { Pagination } from "../../base_classes/pagination";
import { Query } from "../../base_classes/query";

/// ///////////////////////////////////////////////////////////////////////////////////////////////////
/// WARNING! THIS FILE IS AUTOMATICALLY GENERATED, ANY CHANGES WILL BE LOST ON NEXT GENERATION
/// ///////////////////////////////////////////////////////////////////////////////////////////////////

export class AirlineOrderGroupingList
  extends DtoList
  implements IAirlineOrderGroupingList
{
  /// ///////////////////////////////////////
  /// //////// PRIVATE VARIABLES ////////////
  /// ///////////////////////////////////////
  _path = "/airline_order_grouping";

  /// ///////////////////////////////////////
  /// ///////// PUBLIC VARIABLES ////////////
  /// ///////////////////////////////////////
  list: AirlineOrderGrouping[] = [];
  queriedList: AirlineOrderGrouping[] = [];

  /// ///////////////////////////////////////
  /// ////////////// METHODS ////////////////
  /// ///////////////////////////////////////

  _buildInstance(data: JSONData): AirlineOrderGrouping {
    return new AirlineOrderGrouping([], data);
  }

  override async getAll(
    pathVars?: string | string[] | Record<string, string>,
  ): Promise<AirlineOrderGrouping[]> {
    return (await super.getAll(pathVars)) as AirlineOrderGrouping[];
  }

  override async getPaginated(
    pathVars: string | string[],
    pagination: Pagination,
  ): Promise<{
    items: AirlineOrderGrouping[];
    pagination: Pagination;
  }> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return (await super.getPaginated(pathVars, pagination)) as {
      items: AirlineOrderGrouping[];
      pagination: Pagination;
    };
  }

  override async query(
    queries: Query[],
    pagination?: Pagination,
  ): Promise<{
    items: AirlineOrderGrouping[];
    pagination: Pagination;
  }> {
    return (await super.query(queries, pagination)) as {
      items: AirlineOrderGrouping[];
      pagination: Pagination;
    };
  }

  override async search(
    query: string,
    pagination?: Pagination,
  ): Promise<{
    items: AirlineOrderGrouping[];
    pagination: Pagination;
  }> {
    return (await super.search(query, pagination)) as {
      items: AirlineOrderGrouping[];
      pagination: Pagination;
    };
  }
}
